























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ExTextLayer } from "@/model/document2/page/surface/design/layer/exTextLayer";
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { MathHelper } from '@/helper/mathHelper';

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class FontSizeController extends Vue 
{
    @Prop() layer! : ExTextLayer;

    private static readonly AUTO_SIZE_SETTINGS = ["自動OFF", "自動ON", "自動折り返しON"];
    private static readonly MAX_FONT_SIZE = 72;
    private get maxFontSize() { return FontSizeController.MAX_FONT_SIZE; }

    private getAutoSizeMode()
    {
        var isAutoSize = this.layer instanceof PlainTextLayer && this.layer.autoSize;
        var isAutoNewLine = this.layer instanceof PlainTextLayer && this.layer.autoNewLine;
        if(isAutoSize && isAutoNewLine) { return 2; }
        else if(isAutoSize) { return 1; }
        else { return 0; }
    }

    private getTextInfo(name : string)
    {
        if(this.layer.textInfoArray.length == 0) { return this.layer.baseTextInfo[name]; }
        var val = this.layer.textInfoArray[0][name];
        for(var i = 1; i < this.layer.textInfoArray.length; ++i)
        {
            var isEqual = false;
            var lastVal = this.layer.textInfoArray[i][name];
            
            if(typeof(val) == "number")
            {
                if(MathHelper.equals(val, lastVal)) { isEqual = true; }
            }
            else
            {
                if(val == lastVal) { isEqual = true; }
            }
            if(!isEqual) { return null; }
        }

        return val;
    }

    private get fontSize()
    { 
        var value = this.getTextInfo("fontSize");
        return value != null ? Math.min(value, FontSizeController.MAX_FONT_SIZE) : 12;
    }
    private set fontSize(fontSize)
    {
        this.changeTextInfo("fontSize", Number(fontSize), false, false);
    }

    private get fontSizeText()
    {
        return this.fontSize.toFixed(1) + "pt";
    }

    private onFontSizeChanged()
    {
        this.changeTextInfo("fontSize", this.fontSize, true, false);
    }

    private get autoSizeText() 
    {
        var mode = this.getAutoSizeMode();
        return FontSizeController.AUTO_SIZE_SETTINGS[mode];
    }

    private changeAutoSize()
    {
        var mode = this.getAutoSizeMode();
        var newMode = mode + 1;
        if(newMode > 2) { newMode = 0; }
        var isAutoSize = newMode >= 1;
        var isAutoNewLine = newMode == 2;
        this.changeLayerProperty("autoSize", isAutoSize, false, false);
        this.changeLayerProperty("autoNewLine", isAutoNewLine, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }

    private changeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeTextInfo", propertyName, value, isFinish, isOnce);
    }
}
